import {
  getChildren,
  getItemOptions,
  getItemPrefix,
  getItemSuffix,
  getItemValue,
  getName,
  itemShouldDisplay,
  setItemValue,
} from "@shared/features/configuration/utils";
import { ConfigurationItem } from "@shared/types";
import { isEqual } from "lodash";

interface useSharedConfigurationItemProps {
  item: ConfigurationItem;
  valueParser?: (value: any) => any;
  idToItem: Record<number, ConfigurationItem>;
  toggleItemModified: (itemUuid: string, isModified: boolean) => void;
  uuidToOriginalItem: Record<string, ConfigurationItem>;
}

const useSharedConfigurationItem = ({
  item,
  valueParser,
  idToItem,
  toggleItemModified,
  uuidToOriginalItem,
}: useSharedConfigurationItemProps) => {
  const itemValue = getItemValue(item, idToItem);
  const originalItem = item.uuid && uuidToOriginalItem[item.uuid];

  const checkItemModified = (isModified?: boolean) => {
    return toggleItemModified(
      item.uuid || "",
      isModified !== undefined ? isModified : !isEqual(originalItem, item)
    );
  };

  const handleItemChange = (value: any, isModified?: boolean) => {
    let parsedValue = valueParser ? valueParser(value) : value;
    setItemValue(item, parsedValue, idToItem);
    checkItemModified(isModified);
  };

  const itemOptions = getItemOptions(item, idToItem);

  return {
    itemValue,
    checkItemModified,
    handleItemChange,
    itemName: getName(item),
    itemOptions,
    prefix: getItemPrefix(item, idToItem),
    suffix: getItemSuffix(item, idToItem),
    itemChildren: getChildren(item),
    itemShouldDisplay: itemShouldDisplay(item, idToItem),
    originalItemValue: getItemValue(originalItem, idToItem),
  };
};

export default useSharedConfigurationItem;
